import { BssListenersHandler } from './common/bss-listener-handler';
import { commonFunctions } from './common/common-functions';
export var createInit = function (_a) {
    var BSSConnector = _a.BSSConnector;
    var onUpdateFinance = function (ev) {
        var quoteId = ev.detail.params.finance;
        commonFunctions.setQuoteIdInFQS(quoteId);
    };
    return function (options) {
        this.initOptions = options.configuration;
        var _a = this.initOptions, environment = _a.Environment, sessionKey = _a.SessionKey;
        var _b = options.configuration, country = _b.Country, brand = _b.Brand;
        var listenerHandlers = new BssListenersHandler(this, options, onUpdateFinance);
        this.configData = commonFunctions.prepareData(this, this.initOptions);
        this.options.integrationMode =
            options.location === 'body' ? 'inpage' : 'overlayer';
        this.BSSController = new BSSConnector(environment, this.resolutionsConfig, this.version, this.elementType, sessionKey, options.location, {
            lang: this.language,
            brand: brand,
            country: country,
        }, listenerHandlers.getInitBssListenersFunction());
        if (this.options) {
            this.BSSController.setOptions(this.options);
        }
        this.BSSController.setContainer('.bss-entity-container');
        this.BSSController.initFlowWithParams(this.configData);
        this.isInited = true;
    };
};
